import { Button } from 'react-bootstrap';
import { CustomButtonProps } from './custom-button-props.interface';
import { useButtonNavHandler } from './hooks/use-button-nav-handler';
import './button.component.scss';
export const ButtonDefault = ({
  children,
  className,
  path,
  ...rest
}: CustomButtonProps) => {
  const onClickHandler = useButtonNavHandler(path);

  return (
    <Button
      {...rest}
      onClick={onClickHandler ?? rest.onClick}
      className={`${className ? `${className} ` : ''}btn-default`}
    >
      {children}
    </Button>
  );
};
